module.exports = __webpack_public_path__ + "img/ground1_1.0c6130f6.png";